const config = require('../../../../configuration/config');

const PAGE_NAME = 'search_perseus';

const MEDIA_GRID_SM = '600px';
const MEDIA_GRID_MD = '900px';
const MEDIA_GRID_LG = '1160px';
const MEDIA_GRID_XL = '1760px';

const CUSTOM_FILTER_OPTION = 'custom';

const EDUCATION_TOOLTIPS_PREFIX = 'fiverr_education_tooltips';

const ACTIVE_FILTER_SEPARATORS = {
    PARAMS: '|',
    PARAM_VALUE: ':',
    ARRAY_VALUE: ',',
    PAIR_VALUE: '-'
};

const STATIC_FILTERS_MAPPING_SEPARATORS = {
    HYPHEN: '-'
};

const SERIALIZE_LOG_OBJECT_DELIMETERS = {
    ARRAY_DELIMETER: ',',
    KEY_VALUE_DELIMETER: ':',
    PAIRS_DELIMETER: '|'
};

const FLOWS = {
    CATEGORY: 'category',
    SEARCH: 'search',
    PRO_CATEGORY: 'pro_category',
    BUSINESS_CATEGORIES: 'business_categories',
    BUSINESS_SEARCH: 'business_search'
};

const FLOWS_ENRICHMENT = {
    SEARCH_CHOICE_MODALITIES: 'search_gigs_with_modalities',
    LOGO_MAKER_BANNER: 'logo_maker_banner'
};

const LOGO_MAKER_BANNER_SOURCE_PAGE = 'logo_maker_banner';

const HANDLERS = {
    SSR: 'ssr',
    AJAX: 'ajax'
};

const CAROUSEL_SOURCES = {
    YOUR_RECENTLY_VIEWED_GIGS: 'your_recently_viewed_gigs'
};

const CONTEXT_PARAMS_DEFAULTS = {
    page_size: 48,
    page: 1,
    offset: 0,
    view_type: 'grid'
};

const PRO_CONTEXT_PARAMS_DEFAULTS = {
    page_size: 100
};

const USD_CURRENCY = 'USD';

const REPORT_DATA = {
    MAIN: {
        group: 'algos',
        type: 'listings_impression'
    },
    LISTINGS: {
        now_toggle_exists: false,
        now_toggle_used: false,
        pro_toggle_exists: false,
        pro_toggle_used: false,
        view_type: 'grid'
    }
};

const CAROUSEL_POSITIONS = {
    MAIN: 1,
    YOUR_RECENTLY_VIEWED_GIGS: 2
};

const EVENTS_MAPPING = {
    PAGE_VIEWED: {
        mixpanel: 'Viewed page'
    },
    PAGE_CHANGE: {
        mixpanel: 'Paginate'
    },
    FILTERS_APPLY: {
        mixpanel: 'Filtered by',
        biquery: 'applied_filter'
    },
    FILTERS_SKIP: {
        mixpanel: 'Clicked skip'
    },
    FILTERS_ARROW: {
        mixpanel: 'Clicked Arrow'
    },
    FILTERS_BACK: {
        mixpanel: 'Clicked back'
    },
    FILTERS_VIEW_ALL: {
        mixpanel: 'Clicked View All'
    },
    FILTER_REMOVE: {
        mixpanel: 'Removed filter',
        biquery: 'cleared_filter'
    },
    FILTERS_CLEAR_ALL: {
        mixpanel: 'Cleared filters',
        biquery: 'cleared_entire_filters'
    },
    SORT_CHANGE: {
        mixpanel: 'Sort changed',
        biquery: 'changed_sort_by'
    },
    VIEWED_RELATED_SEARCH_TERMS: {
        mixpanel: 'Viewed related search terms'
    },
    VIEWED_CHOICE_MODALITIES: {
        mixpanel: 'Viewed Fiverr Choice Modalities'
    },
    CLICKED_GOT_IT: {
        mixpanel: 'Clicked got it'
    },
    CLICKED_CHOICE_MODALITY: {
        mixpanel: 'Clicked Fiverr Choice Modality'
    },
    MARKETPLACE_CLICK: 'bottom_click.go_to_marketplace',
    CLICK: {
        mixpanel: 'Clicked',
        TARGETS: {
            TOP_FILTER: 'Top Filter: ',
            MORE_FILTERS: 'Top Filter: More Filters',
            SUB_CATEGORY_FILTER: 'Sub Categories Filter',
            NESTED_SUB_CATEGORY_NAV: 'Nested Sub Categories nav',
            GIGS_NSC_SUB_CATEGORY_NAV: 'Gigs Carousel Nested Sub Category Nav',
            HOW_FIVERR_WORKS_VIDEO: 'How Fiverr Works Video In SubCategory',
            SHOW_FILTER_RESULTS: 'Show Filter Results'
        }
    },
    HOVER_PROMOTED_ADS_TOOLTIP: {
        mixpanel: 'Hovered ad tooltip'
    }
};

const FILTERS_LOCATION = {
    TOP: 'Top',
    FLOATING_TOP: 'Floating top',
    FLOATING_TOP_RIGHT: 'Floating top right',
    CLEAR_FLOATING_TOP: 'Clear Floating top',
    CLEAR_FLOATING_TOP_MORE: 'Clear Floating top (more filters)',
    CLEAR_FLOATING_TOP_GROUP: 'Clear Floating top (filter group)',
    MORE_FILTERS: 'More filters',
    SIDEBAR: 'SideBar',
    SELECTED: 'Selected',
    MOBILE_CLEAR_ALL: 'mobile clear all',
    MOBILE_FILTER: 'Filter modal',
    FILTER_RESULTS: 'Filter Results',
    SORT_BY: 'Sort by'
};

const BI_CONSTS = {
    BUTTON: 'button',
    LINK: 'link',
    CHECKBOX: 'checkbox',
    USER_ACTIONS: 'user_actions',
    CLICKED_ON_FILTER_GROUP: 'clicked_on_filter_group',
    WEBSITE_ACTIONS: 'website_actions',
    BUYERS: 'buyers',
    CATERPILLARS: 'caterpillars',
    CLICK: 'click',
    HOVER: 'hover',
    MIXPANEL_PAGE_NAME: 'Sub Category',
    BIGQUERY_PAGE_NAME: 'sub_category'
};

const BI_CLICK_DATA = {
    type: BI_CONSTS.CLICKED_ON_FILTER_GROUP,
    group: BI_CONSTS.USER_ACTIONS,
    sub_group: BI_CONSTS.WEBSITE_ACTIONS,
    action: {
        type: BI_CONSTS.CLICK
    },
    out_of_session: false,
    domain: {
        name: BI_CONSTS.BUYERS
    },
    publisher: {
        domain: BI_CONSTS.BUYERS,
        sub_domain: BI_CONSTS.CATERPILLARS
    }
};

const REQUEST_CONTEXT_FIELDS = [
    'query',
    'flow',
    'currentUser',
    'currency',
    'isTouch',
    'categoryIds',
    'source',
    'view_type',
    'loggedIn',
    'categoryName',
    'subCategoryName',
    'nestedSubCategoryName',
    'should_suggest',
    'showListViewCards',
    'staticFilters',
    'searchAutoComplete',
    'recommendedSubCategoryId',
    'significantLeafCategories',
    'cachedSlug',
    'dominateSubCategoryId',
    'ab_tests'
];

const REQUEST_CONTEXT_DEFAULTS = {
    query: '',
    staticFilters: {}
};

const FULL_INDEX_SIZE = 10;
const HALF_INDEX_SIZE = FULL_INDEX_SIZE / 2;
const MAX_INDEX = 20;

const DEFAULT_GOFOR_OPTIONS = { method: 'GET' };
const DEFAULT_GOFOR_RETIRES = 3;

const SEARCH_DID_YOU_MEAN_SOURCE = 'search_did_you_mean'; // todo arrange sources under a single const
const BREADCRUMBS_SOURCE = 'breadcrumbs';
const SEARCH_AUTOCOMPLETE = 'search-autocomplete';
const SEARCH_AUTOCOMPLETE_ORIGINAL_TERM = `${SEARCH_AUTOCOMPLETE}-original-term`;

const SEARCH_AUTOCOMPLETE_MAPPING = {
    [SEARCH_AUTOCOMPLETE_ORIGINAL_TERM]: () => ['autocomplete_original_term'],
    [`${SEARCH_AUTOCOMPLETE}-type`]: () => ['autocomplete_type'],
    [`${SEARCH_AUTOCOMPLETE}-position`]: (pos) => ['autocomplete_position', pos && Number(pos)],
    [`${SEARCH_AUTOCOMPLETE}-available`]: (isAvailable) => ['is_autocomplete', !!isAvailable]
};

const PERSEUS_ERROR_TYPES = {
    OOPS_PAGE_ERROR: 'oopsPageError'
};

const LOG_LEVELS = {
    ERROR: 'error',
    WARN: 'warn'
};

const STATUS_CODES = {
    BAD_REQUEST: 400
};

const SORT_BY = 'sort-by';

const FIVERR_CHOICE = 'fiverr_choice';
const PROMOTED_GIGS = 'promoted_gigs';

const NSC_PATH_MAPPER = {
    'nsc_tiles_carousel': 'NESTED_SUB_CATEGORY_NAV',
    'gigs_carousel': 'GIGS_NSC_SUB_CATEGORY_NAV'
};

const HOME_TITLES = {
    ROOT: 'fiverr',
    HOME: 'home'
};

const CONTEXT = {
    SUB_CATEGORIES: 'sub_categories'
};

const TRANSLATED_UGC_URL = `${config.machine_translation_service.url}`;
const TRANSLATE_UGC_COOKIE_NAME = 'translate_ugc';
const TOTAL_RESULTS_TRANSLATE_BUTTON_SEPERATOR = '-';

const SUB_CATEGORY_SUB_HEADER = { component: { name: 'sub_category_sub_header' } };
const SEARCH_SUB_HEADER = { component: { name: 'search_sub_header ' }, context: 'search' };
const FLOWS_BI_DATA_UGC_MAPPER = {
    [FLOWS.CATEGORY]: { name: 'sub_category', ...SUB_CATEGORY_SUB_HEADER },
    [FLOWS.SEARCH]: { name: 'search_gigs', ...SEARCH_SUB_HEADER },
    [FLOWS.PRO_CATEGORY]: { name: 'pro_sub_category', ...SUB_CATEGORY_SUB_HEADER }
};

const SUCCESS_UGC_TRANSLATION_STATUS = 200;

const PAIR_FILTERS_IDS_FLP = ['languages_pair'];
const MULTIPLE_FILTERS_IDS_FLP = [ 'multiple_filters'];

const LOGO_DESIGN_SUBCATEGORY_ID = 49;
const VOICE_OVER_SUBCATEGORY_ID = 16;

const LOGO_MAKER_DESKTOP_ROW_POSITION = 4;
const LOGO_MAKER_MOBILE_ROW_POSITION = 5;

const STICKY_COMPONENT_SMALL_SIZE = 70;
const STICKY_COMPONENT_LARGE_SIZE = 110;

const MINIMUM_RELATED_GUIDES = 3;
const BRAND_STYLE_GUIDE_SC_SLUG = 'brand-style-guides';

module.exports = {
    ACTIVE_FILTER_SEPARATORS,
    STATIC_FILTERS_MAPPING_SEPARATORS,
    SERIALIZE_LOG_OBJECT_DELIMETERS,
    FULL_INDEX_SIZE,
    HALF_INDEX_SIZE,
    MAX_INDEX,
    FLOWS,
    FLOWS_ENRICHMENT,
    CONTEXT_PARAMS_DEFAULTS,
    USD_CURRENCY,
    REPORT_DATA,
    CAROUSEL_POSITIONS,
    HOME_TITLES,
    BREADCRUMBS_SOURCE,
    SEARCH_DID_YOU_MEAN_SOURCE,
    REQUEST_CONTEXT_FIELDS,
    REQUEST_CONTEXT_DEFAULTS,
    DEFAULT_GOFOR_RETIRES,
    DEFAULT_GOFOR_OPTIONS,
    MEDIA_GRID_SM,
    MEDIA_GRID_MD,
    MEDIA_GRID_LG,
    MEDIA_GRID_XL,
    SEARCH_AUTOCOMPLETE,
    SEARCH_AUTOCOMPLETE_ORIGINAL_TERM,
    SEARCH_AUTOCOMPLETE_MAPPING,
    FILTERS_LOCATION,
    EVENTS_MAPPING,
    CAROUSEL_SOURCES,
    HANDLERS,
    PERSEUS_ERROR_TYPES,
    STATUS_CODES,
    SORT_BY,
    LOG_LEVELS,
    FIVERR_CHOICE,
    PROMOTED_GIGS,
    BI_CLICK_DATA,
    BI_CONSTS,
    NSC_PATH_MAPPER,
    PRO_CONTEXT_PARAMS_DEFAULTS,
    TRANSLATED_UGC_URL,
    TRANSLATE_UGC_COOKIE_NAME,
    TOTAL_RESULTS_TRANSLATE_BUTTON_SEPERATOR,
    FLOWS_BI_DATA_UGC_MAPPER,
    SUCCESS_UGC_TRANSLATION_STATUS,
    PAGE_NAME,
    LOGO_DESIGN_SUBCATEGORY_ID,
    LOGO_MAKER_DESKTOP_ROW_POSITION,
    LOGO_MAKER_MOBILE_ROW_POSITION,
    PAIR_FILTERS_IDS_FLP,
    MULTIPLE_FILTERS_IDS_FLP,
    LOGO_MAKER_BANNER_SOURCE_PAGE,
    CONTEXT,
    VOICE_OVER_SUBCATEGORY_ID,
    STICKY_COMPONENT_SMALL_SIZE,
    STICKY_COMPONENT_LARGE_SIZE,
    CUSTOM_FILTER_OPTION,
    EDUCATION_TOOLTIPS_PREFIX,
    MINIMUM_RELATED_GUIDES,
    BRAND_STYLE_GUIDE_SC_SLUG
};
